import '../../../shared-components/CycoPageForm/CycoPage.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import TwoColumnLayout from '../../../framework/components/Templates/TwoColumnLayout/TwoColumnLayout';
import BodyHeader from '../../../shared-components/BodyHeader/BodyHeader';
import CycoPageForm from '../../../shared-components/CycoPageForm/CycoPageForm';
import FormattedRemoteHTMLMessage from '../../../shared-components/FormattedRemoteHTMLMessage/FormattedRemoteHTMLMessage';

const LOCALE_PREFIX = 'GB/pages/CycoPage/CycoPage';

export class CycoPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        isReuse: PropTypes.bool.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
    };

    static defaultProps = {
        isReuse: false,
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }


    render() {
        const { isReuse, intl } = this.props;

        // utils
        const pageName = 'cycopage';
        const isAcq = !isReuse;
        const acqOrReuse = isAcq ? 'acq' : 'reuse';

        const defaultMessage = 'cyco-message';
        if (isReuse) {
            // We want to update the HTML head title for Reuse to "PayPal Checkout" as CAPE generally shows "Apply for PayPal Credit".
            document.title = intl.formatMessage({id: `${LOCALE_PREFIX}.cyco-page-html-head-title-reuse`});
        }
     
        const representativeExample = (
            <div className="representative-container">
                <div className="representative-header">
                    <FormattedRemoteHTMLMessage id="representativeExample.subHeader" />
                </div>
                <dl>
                    <dt>
                        <FormattedRemoteHTMLMessage id="representativeExample.APR" />
                    </dt>
                    <dd>
                        <FormattedRemoteHTMLMessage id="representativeExample.APRValue" />
                    </dd>
                    <dt>
                        <FormattedRemoteHTMLMessage id="representativeExample.purchaseRate" />
                    </dt>
                    <dd>
                        <FormattedRemoteHTMLMessage id="representativeExample.purchaseRateValue" />
                    </dd>
                    <dt>
                        <FormattedRemoteHTMLMessage id="representativeExample.creditLimit" />
                    </dt>
                    <dd>
                        <FormattedRemoteHTMLMessage id="representativeExample.creditLimitValue" />
                    </dd>
                </dl>
                <p className="representative-paragraph">
                    <FormattedRemoteHTMLMessage id="representativeExample.header" />
                </p>
            </div>
        );
             

        const classes = [
            'CycoPage',
            'CycoPage--ni',
            (isAcq ? 'CycoPage--acquisition' : 'CycoPage--reuse')
        ];

        return (
            <TwoColumnLayout pageName={classes.join(' ')}>
                <BodyHeader />
                <CycoPageForm
                    pageName={pageName}
                    isAcq={isAcq}
                    isReuse={isReuse}
                    acqOrReuse={acqOrReuse}
                />
                {representativeExample}
            </TwoColumnLayout>    
        );
    }
}


export const mapStateToProps = (state, ownProps) => ({
    isReuse: _.get(state, 'serverData.isReuse', false),
});

export const mapDispatchToProps = (dispatch, ownProps) => {
    const pageName = 'cycopage';
    return {
        onComponentDidMount() {
            dispatch(trackTransition(`pp_credit_${pageName}`, `prepare_pp_credit_${pageName}`));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CycoPage));
